/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/tractor'
export default icon
